"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/esnext.json.parse.js");
var _hike = require("@/api/hike");
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _lifehikesInitData = require("@/lifehikes-init-data");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SendSurveyNotification',
  data() {
    return {
      hikeId: this.$route.params.id,
      internalTitle: '',
      loading: false,
      participantList: [],
      benchmarkBossSurveyId: '',
      benchmarkPeerSurveyId: '',
      benchmarkDirectReportSurveyId: '',
      summitBossSurveyId: '',
      summitPeerSurveyId: '',
      summitDirectReportSurveyId: ''
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;

      // 1. getSurveyTeamEmails
      (0, _hike.getSurveyTeamEmails)(token, {
        hikeId: this.hikeId
      }).then(response => {
        (0, _log.showDebugLog)('Hike-getSurveyTeamEmails-response', response.data);
        const rows = response.data.rows;
        if (rows.length) {
          this.benchmarkBossSurveyId = rows[0].surveys.benchmarkBossSurveyId;
          this.benchmarkPeerSurveyId = rows[0].surveys.benchmarkPeerSurveyId;
          this.benchmarkDirectReportSurveyId = rows[0].surveys.benchmarkDirectReportSurveyId;
          this.summitBossSurveyId = rows[0].surveys.summitBossSurveyId;
          this.summitPeerSurveyId = rows[0].surveys.summitPeerSurveyId;
          this.summitDirectReportSurveyId = rows[0].surveys.summitDirectReportSurveyId;

          // 2. getEmailLog
          Promise.all([(0, _hike.getEmailLog)(token, {
            hikeId: this.hikeId,
            surveyId: this.benchmarkBossSurveyId
          }), (0, _hike.getEmailLog)(token, {
            hikeId: this.hikeId,
            surveyId: this.benchmarkPeerSurveyId
          }), (0, _hike.getEmailLog)(token, {
            hikeId: this.hikeId,
            surveyId: this.benchmarkDirectReportSurveyId
          }), (0, _hike.getEmailLog)(token, {
            hikeId: this.hikeId,
            surveyId: this.summitBossSurveyId
          }), (0, _hike.getEmailLog)(token, {
            hikeId: this.hikeId,
            surveyId: this.summitPeerSurveyId
          }), (0, _hike.getEmailLog)(token, {
            hikeId: this.hikeId,
            surveyId: this.summitDirectReportSurveyId
          })]).then(([benchmarkBossResponse, benchmarkPeerResponse, benchmarkDirectReportResponse, bossResponse, peerResponse, directReportResponse]) => {
            this.loading = false;
            (0, _log.showDebugLog)('Hike-getEmailLog-response', benchmarkBossResponse.data);
            (0, _log.showDebugLog)('Hike-getEmailLog-response', benchmarkPeerResponse.data);
            (0, _log.showDebugLog)('Hike-getEmailLog-response', benchmarkDirectReportResponse.data);
            (0, _log.showDebugLog)('Hike-getEmailLog-response', bossResponse.data);
            (0, _log.showDebugLog)('Hike-getEmailLog-response', peerResponse.data);
            (0, _log.showDebugLog)('Hike-getEmailLog-response', directReportResponse.data);
            const benchmarkBossEmailLog = benchmarkBossResponse.data.rows;
            const benchmarkPeerEmailLog = benchmarkPeerResponse.data.rows;
            const benchmarkDirectReportEmailLog = benchmarkDirectReportResponse.data.rows;
            const submitBossEmailLog = bossResponse.data.rows;
            const summitPeerEmailLog = peerResponse.data.rows;
            const summitDirectReportEmailLog = directReportResponse.data.rows;

            // Convert to appropriate tabular data
            const participantList = [];
            rows.forEach(row => {
              row.bossEmails.forEach(email => {
                const newRow = JSON.parse(JSON.stringify(row));
                newRow.emailType = 'boss';
                newRow.email = email;
                newRow.isSendBenchmark = benchmarkBossEmailLog.findIndex(log => log.participantId === row.participantId && log.toStr === email) > -1 ? 'Y' : 'N';
                newRow.isSendSummit = submitBossEmailLog.findIndex(log => log.participantId === row.participantId && log.toStr === email) > -1 ? 'Y' : 'N';
                participantList.push(newRow);
              });
              row.peerEmails.forEach(email => {
                const newRow = JSON.parse(JSON.stringify(row));
                newRow.emailType = 'peer';
                newRow.email = email;
                newRow.isSendBenchmark = benchmarkPeerEmailLog.findIndex(log => log.participantId === row.participantId && log.toStr === email) > -1 ? 'Y' : 'N';
                newRow.isSendSummit = summitPeerEmailLog.findIndex(log => log.participantId === row.participantId && log.toStr === email) > -1 ? 'Y' : 'N';
                participantList.push(newRow);
              });
              row.dmEmails.forEach(email => {
                const newRow = JSON.parse(JSON.stringify(row));
                newRow.emailType = 'dm';
                newRow.email = email;
                newRow.isSendBenchmark = benchmarkDirectReportEmailLog.findIndex(log => log.participantId === row.participantId && log.toStr === email) > -1 ? 'Y' : 'N';
                newRow.isSendSummit = summitDirectReportEmailLog.findIndex(log => log.participantId === row.participantId && log.toStr === email) > -1 ? 'Y' : 'N';
                participantList.push(newRow);
              });
            });
            this.participantList = participantList;
          }).catch(error => {
            (0, _log.showDebugLog)('Hike-getEmailLog-error', error);
            this.loading = false;
            (0, _log.displayPopupMessage)(error, 'error');
          });
        }
      }).catch(error => {
        (0, _log.showDebugLog)('Hike-getSurveyTeamEmails-error', error);
        this.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    sort_change(column) {
      let newItems = this.participantList.sort(this.sortFun(column.prop));
      if (column.order === "descending") {
        newItems = newItems.reverse();
      }
      this.participantList = newItems;
      //console.info("sort a:"+JSON.stringify(this.participantList));
    },
    sortFun(attr) {
      return function (item1, item2) {
        item1 = item1[attr].toLowerCase();
        item2 = item2[attr].toLowerCase();
        if (item1 < item2) {
          return -1;
        } else if (item1 > item2) {
          return 1;
        } else {
          return 0;
        }
      };
    },
    send(row, surveyType) {
      this.loading = true;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _hike.sendMail)(token, {
        surveyId: this.getSurveyId(surveyType, row.emailType),
        uuid: row.participantId,
        email: row.email,
        name: row.participantGivenName + ' ' + row.participantFamilyName,
        hikeId: this.hikeId
      }).then(response => {
        (0, _log.showDebugLog)('Hike-sendEmail-response', response.data);

        //const msg = `Survey notification has been sent.`
        if (response.data.message === 'Fail') {
          const msg = response.data.reason;
          (0, _log.displayPopupMessage)(msg, 'error');
        } else {
          const msg = response.data.reason;
          (0, _log.displayPopupMessage)(msg, 'success');
        }
        this.getData();
      }).catch(error => {
        (0, _log.showDebugLog)('Hike-sendEmail-error', error);
        this.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    batchSend(surveyType) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      if (this.$refs.participantList.selection.length < 1) {
        (0, _log.displayPopupMessage)('Please select emails.', 'warning');
        return;
      }
      this.loading = true;
      const sendEmailPromises = this.$refs.participantList.selection.map(row => {
        return (0, _hike.sendMail)(token, {
          surveyId: this.getSurveyId(surveyType, row.emailType),
          uuid: row.participantId,
          email: row.email,
          name: row.participantGivenName + ' ' + row.participantFamilyName,
          hikeId: this.hikeId
        });
      });
      Promise.all(sendEmailPromises).then(responses => {
        (0, _log.showDebugLog)('Hike-sendEmail-response', responses);
        const msg = `Survey notifications have been sent.`;
        (0, _log.displayPopupMessage)(msg, 'success');
        this.getData();
      }).catch(error => {
        (0, _log.showDebugLog)('Hike-sendEmail-error', error);
        this.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    getSurveyId(surveyType, emailType) {
      if (emailType === 'boss') {
        return this[surveyType + 'BossSurveyId'];
      } else if (emailType === 'peer') {
        return this[surveyType + 'PeerSurveyId'];
      } else if (emailType === 'dm') {
        return this[surveyType + 'DirectReportSurveyId'];
      }
    }
  }
};